import { RouteRecordRaw } from "vue-router";
//Start General routes module///////////////////////////////////////////////////////////////////////////////////////////////
export const merchantAppRoutes: Array<RouteRecordRaw> = [
	{
		path: "/:language(en|ar|)?/merchant",
		component: () => import("@/merchant/layout/Layout.vue"),
		meta: {
			type: "app",
		},
		children: [
			{
				path: "",
				name: "merchant-empty",
				component: () => import("@/merchant/views/dashboard/Dashboard.vue"),
			},
			{
				path: "no-permission",
				name: "merchant-no-permission",
				component: () => import("@/merchant/views/NoPermission.vue"),
			},
			{
				path: "comming-soon",
				name: "merchant-comming-soon",
				component: () => import("@/merchant/views/CommingSoon.vue"),
			},
			//End General routes module///////////////////////////////////////////////////////////////////////////////////////////
			//Start Dashbord module///////////////////////////////////////////////////////////////////////////////////////////////
			{
				path: "dashboard",
				children: [
					{
						path: "",
						name: "merchant-dashboard",
						component: () => import("@/merchant/views/dashboard/Dashboard.vue"),
					},
				],
			},
			//End Dashbord module///////////////////////////////////////////////////////////////////////////////////////////////
			//Start my clouds modules //////////////////////////////////////////////////////////////////////////////////////////
			{
				path: "my-clouds",
				name: "merchant-profile",
				component: () => import("@/merchant/views/my-clouds/Profile.vue"),
			},
			{
				path: "my-clouds",
				children: [
					{
						path: "my-profile",
						name: "merchant-my-clouds-my-profile",
						component: () => import("@/merchant/views/my-clouds/Profile.vue"),
					},
					{
						path: "my-attendance",
						name: "merchant-my-clouds-my-attendance",
						component: () => import("@/merchant/views/my-clouds/MyAttendance.vue"),
					},
					{
						path: "my-leaves",
						name: "merchant-my-clouds-my-leaves",
						component: () => import("@/merchant/views/my-clouds/MyLeaves.vue"),
					},
					/*{
						path: "my-requests",
						name: "merchant-my-clouds-my-requests",
						component: () => import("@/merchant/views/my-clouds/MyRequest.vue"),
					},*/
				],
			},

			//End My Clouds////////////////////////////////////////////////////////////////////////////////////////////////////
			//Start human Resources module/////////////////////////////////////////////////////////////////////////////////////
			{
				path: "human-resources",
				children: [
					{
						path: "hr-dashboard",
						name: "merchant-human-resources-hr-dashboard",
						component: () => import("@/merchant/views/human-resources/HrDashboard.vue"),
					},
					{
						path: "attendence-chart",
						name: "merchant-human-attendence-chart",
						component: () => import("@/merchant/views/human-resources/AttendenceChart.vue"),
					},
					{
						path: "attendence",
						name: "merchant-human-resources-attendence",
						component: () => import("@/merchant/views/human-resources/Attendence.vue"),
					},
					{
						path: "hr-reports",
						name: "merchant-employees-hr-reports",
						component: () => import("@/merchant/views/human-resources/HrReports.vue"),
					},
					{
						path: "hr-reports",
						children: [
							{
								path: "employee-attendence-report",
								name: "merchant-human-resouces-employee-attendence-report",
								component: () => import("@/merchant/views/human-resources/hr-reports/EmployeeAttendenceReport.vue"),
							},
							{
								path: "detailed-attendence-report",
								name: "merchant-human-resouces-reports-detailed-attendence-report",
								component: () => import("@/merchant/views/human-resources/hr-reports/DetailedAttendenceReport.vue"),
							},
							{
								path: "leaving-report",
								name: "merchant-human-resouces-reports-leaving-report",
								component: () => import("@/merchant/views/human-resources/hr-reports/LeavingReport.vue"),
							},
							{
								path: "under-timing-report",
								name: "merchant-human-resouces-reports-under-timing-report",
								component: () => import("@/merchant/views/human-resources/hr-reports/UnderTimingReport.vue"),
							},
							{
								path: "commulative-attendence-report",
								name: "merchant-human-resouces-commulative-attendence-report",
								component: () => import("@/merchant/views/human-resources/hr-reports/CommulativeAttendenceReport.vue"),
							},
							{
								path: "salary-certificates",
								name: "merchant-human-resouces-reports-salary-certificates",
								component: () => import("@/merchant/views/human-resources/salary-certificates/SalaryCertificates.vue"),
							},
							{
								path: "salary-certificate",
								name: "merchant-human-resouces-reports-salary-certificates-add",
								component: () => import("@/merchant/views/human-resources/salary-certificates/SalaryCertificate.vue"),
							},
							{
								path: "salary-certificate/:id",
								name: "merchant-human-resouces-reports-salary-certificates-view",
								component: () => import("@/merchant/views/human-resources/salary-certificates/SalaryCertificate.vue"),
							},
						],
					},
					{
						path: "",
						children: [
							{
								path: "employees",
								name: "merchant-human-resources-employees",
								component: () => import("@/merchant/views/human-resources/Employees.vue"),
							},
							{
								path: "employee-form",
								name: "merchant-human-resources-employeeform",
								component: () => import("@/merchant/views/human-resources/EmployeeForm.vue"),
							},
							{
								path: "employee-form/:id",
								name: "merchant-human-resources-employeeform-edit",
								component: () => import("@/merchant/views/human-resources/EmployeeForm.vue"),
							},
						],
					},
					{
						path: "employees-documents",
						name: "merchant-human-resources-employees-documents",
						component: () => import("@/merchant/views/human-resources/EmployeesDocuments.vue"),
					},
					{
						path: "employees-dependents",
						name: "merchant-human-resources-employees-dependents",
						component: () => import("@/merchant/views/human-resources/Dependents.vue"),
					},
					{
						path: "employees-dependents-documents",
						name: "merchant-human-resources-employees-dependents-documents",
						component: () => import("@/merchant/views/human-resources/DependentsDocuments.vue"),
					},
					{
						path: "security",
						name: "merchant-human-resources-security",
						component: () => import("@/merchant/views/human-resources/Security.vue"),
					},
					{
						path: "audit-logs",
						name: "merchant-human-resources-audit-logs",
						component: () => import("@/merchant/views/human-resources/AuditLogs.vue"),
					},
				],
			},

			//End Human Resources///////////////////////////////////////////////////////////////////////////////////////////////////
			//Start Information Technology//////////////////////////////////////////////////////////////////////////////////////////
			{
				path: "information-technology",
				children: [
					{
						path: "it-dashboard",
						name: "merchant-information-technology-dashboard",
						component: () => import("@/merchant/views/information-technology/ItDashboard.vue"),
					},
					{
						path: "it-users",
						name: "merchant-information-technology-users",
						component: () => import("@/merchant/views/information-technology/ItUsers.vue"),
					},

					{
						path: "it-user-form",
						name: "merchant-information-technology-ituserform",
						component: () => import("@/merchant/views/information-technology/ItUserForm.vue"),
					},
					{
						path: "it-user-form/:id",
						name: "merchant-information-technology-ituserform-edit",
						component: () => import("@/merchant/views/information-technology/ItUserForm.vue"),
					},
					{
						path: "it-new-user-form",
						name: "merchant-information-technology-itnewuserform",
						component: () => import("@/merchant/views/information-technology/ItNewUserForm.vue"),
					},
					{
						path: "it-new-user-form/:id",
						name: "merchant-information-technology-itnewuserform-edit",
						component: () => import("@/merchant/views/information-technology/ItNewUserForm.vue"),
					},
					{
						path: "",
						children: [
							{
								path: "it-assets",
								name: "merchant-information-technology-it-assets",
								component: () => import("@/merchant/views/information-technology/ItAssets.vue"),
							},
							{
								path: "it-asset-form",
								name: "merchant-information-technology-it-asset-form",
								component: () => import("@/merchant/views/information-technology/ItAssetForm.vue"),
							},
							{
								path: "it-asset-form/:id",
								name: "merchant-information-technology-it-asset-form-edit",
								component: () => import("@/merchant/views/information-technology/ItAssetForm.vue"),
							},
							{
								path: "it-asset-form/:id?operation=view",
								name: "merchant-information-technology-it-asset-form-view",
								component: () => import("@/merchant/views/information-technology/ItAssetForm.vue"),
							},
						],
					},
					{
						path: "contact-lists",
						name: "merchant-information-technology-contact-lists",
						component: () => import("@/merchant/views/information-technology/ContactLists.vue"),
					},
					{
						path: "contact-lists",
						children: [
							{
								path: "contact-list",
								name: "merchant-information-technology-contact-lists-contact-list",
								component: () => import("@/merchant/views/information-technology/contact-lists/ContactList.vue"),
							},
							{
								path: "by-location",
								name: "merchant-information-technology-contact-lists-by-location",
								component: () => import("@/merchant/views/information-technology/contact-lists/ByLocation.vue"),
							},
							{
								path: "speed-dial",
								name: "merchant-information-technology-contact-lists-speed-dial",
								component: () => import("@/merchant/views/information-technology/contact-lists/SpeedDial.vue"),
							},
						],
					},
					{
						path: "it-errors",
						name: "merchant-information-technology-it-errors",
						component: () => import("@/merchant/views/information-technology/ItErrors.vue"),
					},
					{
						path: "it-tickets",
						name: "merchant-information-technology-it-tickets",
						component: () => import("@/merchant/views/information-technology/ItTickets.vue"),
					},
					{
						path: "audit-logs",
						name: "merchant-information-technology-audit-logs",
						component: () => import("@/merchant/views/information-technology/AuditLogs.vue"),
					},
				],
			},

			//End Information Technology////////////////////////////////////////////////////////////////////////////////////////////
			//Start Storage Section ////////////////////////////////////////////////////////////////////////////////////////////
			{
				path: "storage",
				children: [
					{
						path: "storage-dashboard",
						name: "merchant-storage-dashboard",
						component: () => import("@/merchant/views/storage/storage-dashboard/StorageDashboard.vue"),
					},

					{
						path: "",
						children: [
							{
								path: "add-production",
								name: "merchant-storage-dashboard-add-production",
								component: () => import("@/merchant/views/storage/storage-dashboard/AddProduction.vue"),
							},
							{
								path: "added-productions",
								name: "merchant-storage-dashboard-added-productions",
								component: () => import("@/merchant/views/storage/storage-dashboard/AddedProductions.vue"),
							},
						],
					},

					{
						path: "production-planned-time",
						name: "merchant-storage-production-planned-time",
						component: () => import("@/merchant/views/storage/ProductionPlannedTime.vue"),
					},
				],
			},
			//end Storage Section ////////////////////////////////////////////////////////////////////////////////////////////
			//Start Accounting Modules//////////////////////////////////////////////////////////////////////////////////////////
			{
				path: "storage",

				children: [
					{
						path: "storage",
						children: [
							{
								path: "",
								name: "merchant-accounting-total-sales",
								component: () => import("@/merchant/views/accounting/total-sales/TotalSales.vue"),
							},
						],
					},
					{
						path: "expenses",
						children: [
							{
								path: "",
								name: "merchant-accounting-expenses",
								component: () => import("@/merchant/views/accounting/expenses/Expenses.vue"),
							},
							{
								path: "expenses",
								children: [
									{
										path: "",
										name: "merchant-accounting-expenses-expenses",
										component: () => import("@/merchant/views/accounting/expenses/expenses/Expenses.vue"),
									},
									{
										path: "expense",
										name: "merchant-accounting-expenses-expenses-expense",
										component: () => import("@/merchant/views/accounting/expenses/expenses/Expense.vue"),
									},
									{
										path: "expense/:id",
										name: "merchant-accounting-expenses-expenses-expense-edit",
										component: () => import("@/merchant/views/accounting/expenses/expenses/Expense.vue"),
									},
								],
							},
							{
								path: "expected-expenses",
								children: [
									{
										path: "",
										name: "merchant-accounting-expenses-expected-expenses",
										component: () => import("@/merchant/views/accounting/expenses/expected-expenses/ExpectedExpenses.vue"),
									},
									{
										path: "expense",
										name: "merchant-accounting-expenses-expected-expenses-expense",
										component: () => import("@/merchant/views/accounting/expenses/expected-expenses/ExpectedExpense.vue"),
									},
									{
										path: "expense/:id",
										name: "merchant-accounting-expenses-expected-expenses-expense-edit",
										component: () => import("@/merchant/views/accounting/expenses/expected-expenses/ExpectedExpense.vue"),
									},
								],
							},
							{
								path: "suppliers",
								name: "merchant-accounting-expenses-suppliers",
								component: () => import("@/merchant/views/accounting/expenses/Suppliers.vue"),
							},
							{
								path: "suppliers/:id",
								name: "merchant-accounting-expenses-supplier",
								component: () => import("@/merchant/views/accounting/expenses/Supplier.vue"),
							},
						],
					},

					{
						path: "customers",
						name: "merchant-customers",
						component: () => import("@/merchant/views/accounting/Customers.vue"),
					},
					{
						path: "customers/:id",
						name: "merchant-customers-customer",
						component: () => import("@/merchant/views/accounting/Customer.vue"),
					},
					{
						path: "payments",
						name: "merchant-accounting-payments",
						component: () => import("@/merchant/views/accounting/Payments.vue"),
					},
					{
						path: "accounting-notes",
						name: "merchant-accounting-accounting-notes",
						component: () => import("@/merchant/views/accounting/AccountingNotes.vue"),
					},
					{
						path: "receivable",
						name: "merchant-accounting-receivable",
						component: () => import("@/merchant/views/accounting/Receivable.vue"),
					},
					{
						path: "accounting-reports",
						children: [
							{
								path: "",
								name: "merchant-reports-accounting-reports",
								component: () => import("@/merchant/views/reports/accounting-reports/AccountingReports.vue"),
							},
							{
								path: "daily-general-summary",
								name: "merchant-reports-accounting-reports-daily-general-summary",
								component: () => import("@/merchant/views/reports/accounting-reports/DailyGeneralSummary.vue"),
							},
							{
								path: "monthly-general-summary",
								name: "merchant-reports-accounting-reports-monthly-general-summary",
								component: () => import("@/merchant/views/reports/accounting-reports/MonthlyGeneralSummary.vue"),
							},
							{
								path: "general-summary-per-cashier-employees",
								name: "merchant-reports-accounting-reports-general-summary-per-cashier-employees",
								component: () => import("@/merchant/views/reports/accounting-reports/GeneralSummaryPerCashierEmployees.vue"),
							},
							{
								path: "daily-payments-summary",
								name: "merchant-reports-accounting-reports-daily-payments-summary",
								component: () => import("@/merchant/views/reports/accounting-reports/DailyPaymentsReport.vue"),
							},
							{
								path: "monthly-payments-summary",
								name: "merchant-reports-accounting-reports-monthly-payments-summary",
								component: () => import("@/merchant/views/reports/accounting-reports/MonthlyPaymentsReport.vue"),
							},

							{
								path: "credit-notes",
								name: "merchant-reports-accounting-reports-credit-notes",
								component: () => import("@/merchant/views/reports/accounting-reports/CreditNotes.vue"),
							},
							{
								path: "debit-notes",
								name: "merchant-reports-accounting-reports-debit-notes",
								component: () => import("@/merchant/views/reports/accounting-reports/DebitNotes.vue"),
							},
							{
								path: "profit-and-loss",
								name: "merchant-reports-accounting-reports-profit-and-loss",
								component: () => import("@/merchant/views/reports/accounting-reports/ProfitAndLoss.vue"),
							},
							{
								path: "vat-report",
								name: "merchant-reports-accounting-reports-vat-report",
								component: () => import("@/merchant/views/reports/accounting-reports/VAT.vue"),
							},
						],
					},
				],
			},
			{
				path: "system-manager",
				children: [
					{
						path: "roles-and-permissions",
						name: "merchant-system-manager-roles",
						component: () => import("@/merchant/views/system-manager/Roles.vue"),
					},
					{
						path: "role",
						name: "merchant-system-manager-roles-role",
						component: () => import("@/merchant/views/system-manager/Role.vue"),
					},
					{
						path: "role/:id",
						name: "merchant-system-manager-roles-edit",
						component: () => import("@/merchant/views/system-manager/Role.vue"),
					},
				],
			},
			{
				path: "system-manager",
				children: [
					{
						path: "general-setting",
						children: [
							{
								path: "",
								name: "merchant-setting-general-setting",
								component: () => import("@/merchant/views/system-manager/general-setting/GeneralSetting.vue"),
							},
							{
								path: "account-invoice/:uniqueId",
								name: "merchant-setting-general-setting-account-invoice",
								component: () => import("@/merchant/views/system-manager/general-setting/AccountInvoice.vue"),
							},
						],
					},
					{
						path: "invoice-setting",
						name: "merchant-setting-invoice-setting",
						component: () => import("@/merchant/views/system-manager/InvoiceSetting.vue"),
					},
					{
						path: "accounting-setting",
						name: "merchant-setting-accounting-setting",
						component: () => import("@/merchant/views/system-manager/AccountingSetting.vue"),
					},
					{
						path: "notifications-setting",
						name: "merchant-setting-notifications-setting",
						component: () => import("@/merchant/views/system-manager/NotificationsSetting.vue"),
					},
					{
						path: "master-data",
						name: "merchant-setting-master-data",
						component: () => import("@/merchant/views/system-manager/MasterData.vue"),
					},
					{
						path: "",
						children: [
							{
								path: "section",
								name: "merchant-master-data-section",
								component: () => import("@/merchant/views/system-manager/master-data/Sections.vue"),
							},
							{
								path: "departments",
								name: "merchant-master-data-departments",
								component: () => import("@/merchant/views/system-manager/master-data/Departments.vue"),
							},
							{
								path: "shifts",
								name: "merchant-master-data-shifts",
								component: () => import("@/merchant/views/system-manager/master-data/Shifts.vue"),
							},
							{
								path: "working_locations",
								name: "merchant-master-data-working-locations",
								component: () => import("@/merchant/views/system-manager/master-data/WorkingLocations.vue"),
							},
							{
								path: "assets_types",
								name: "merchant-master-data-assets-types",
								component: () => import("@/merchant/views/system-manager/master-data/AssetsTypes.vue"),
							},
							{
								path: "assets_brands",
								name: "merchant-master-data-assets-brands",
								component: () => import("@/merchant/views/system-manager/master-data/AssetsBrands.vue"),
							},
							{
								path: "effected_items",
								name: "merchant-master-data-effected-items",
								component: () => import("@/merchant/views/system-manager/master-data/AssetItems.vue"),
							},
							{
								path: "it_locations",
								name: "merchant-master-data-it-locations",
								component: () => import("@/merchant/views/system-manager/master-data/ItLocations.vue"),
							},
						],
					},
				],
			},
			{
				path: "billing",
				name: "merchant-billing",
				component: () => import("@/merchant/views/Billing.vue"),
			},
			{
				path: "on-hold-report",
				name: "merchant-on-hold-report",
				component: () => import("@/merchant/views/OnHoldReport.vue"),
			},
			{
				path: "logout",
				name: "merchant-logout",
				component: () => import("@/merchant/views/SignIn.vue"),
			},
		],
	},
	{
		path: "/:language(en|ar|)?/",
		component: () => import("@/merchant/layout/AuthLayout.vue"),
		children: [
			{
				path: "",
				name: "merchant-sign-in",
				component: () => import("@/merchant/views/SignIn.vue"),
			},
			{
				path: "reset-password/:token",
				name: "merchant-reset-password",
				component: () => import("@/merchant/views/ResetPassword.vue"),
			},
		],
	},
	{
		path: "/:language(en|ar|)?/attendence-system/:uuid",
		name: "merchant-all-attendence-system",
		component: () => import("@/merchant/views/AllAttendenceSystem.vue"),
	},
	{
		path: "/:language(en|ar|)?/it-ticket",
		name: "merchant-it-ticket",
		component: () => import("@/merchant/views/ItTicket.vue"),
	},
	{
		path: "/:language(en|ar|)?/face-data/:uuid",
		name: "merchant-face-data",
		component: () => import("@/merchant/views/FaceData.vue"),
	},
];

export const merchantGeneralRoutes: Array<RouteRecordRaw> = [];
